import React from "react";
import { TrendingUp, FileText, Download } from "react-feather";

function AccountingTaxes() {
  // Demo data based on wireframe
  const commission = {
    totalValue: 50000,
    wTax: 4000,
  };

  const remittance = {
    pending: 70000,
    remittedViaNexus: {
      total: 46000,
      processing: 8000
    }
  };

  return (
    <div className="card shadow p-4">
      <div className="mb-4">
        <h4 className="mb-1">Accounting Taxes Page</h4>
        <p className="text-muted mb-4">This page shows taxes (commission)</p>

        {/* Commission Taxes Section */}
        <div className="mb-5">
          <div className="d-flex align-items-center mb-3">
            <h5 className="mb-1 me-2">Commission Taxes (Taxes realized from Your Commission)</h5>
          </div>
          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body d-flex align-items-center">
                  <TrendingUp size={40} className="text-primary me-3" />
                  <div>
                    <h6 className="card-title mb-1" style={{ fontSize: "1.0rem", fontWeight: "600" }}>Total Value</h6>
                    <p className="card-text mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      KES {commission.totalValue.toLocaleString()}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body d-flex align-items-center">
                  <TrendingUp size={40} className="text-warning me-3" />
                  <div>
                    <h6 className="card-title mb-1" style={{ fontSize: "1.0rem", fontWeight: "600" }}>W-Tax</h6>
                    <p className="card-text mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                      KES {commission.wTax.toLocaleString()}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Remittance Section */}
        <div className="mb-5">
          <div className="d-flex align-items-center mb-3">
            <h5 className="mb-1 me-2">Remittance (How you have remitted your Taxes)</h5>
          </div>
          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <TrendingUp size={40} className="text-info me-3" />
                    <div>
                      <h6 className="card-title mb-1" style={{ fontSize: "1.0rem", fontWeight: "600" }}>Pending Remittance</h6>
                      <p className="card-text mb-0" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                        KES {remittance.pending.toLocaleString()}
                      </p>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2">
                    <button className="btn btn-outline-primary btn-sm">View All</button>
                    <button className="btn btn-outline-success btn-sm">Mark All as Remitted</button>
                    <button className="btn btn-outline-info btn-sm">Remit Via Nexus</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <TrendingUp size={40} className="text-success me-3" />
                    <div className="flex-grow-1">
                      <h6 className="card-title mb-1" style={{ fontSize: "1.0rem", fontWeight: "600" }}>Remitted Via Nexus</h6>
                    </div>
                  </div>
                  
                  {/* Total and Processing breakdown */}
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="text-muted">Total:</span>
                      <span className="fw-bold">KES {remittance.remittedViaNexus.total.toLocaleString()}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted">Processing:</span>
                      <span className="fw-bold text-warning">KES {remittance.remittedViaNexus.processing.toLocaleString()}</span>
                    </div>
                  </div>
                  
                  <button className="btn btn-outline-primary btn-sm w-100">View All</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Reports Section */}
        <div>
          <div className="d-flex align-items-center mb-3">
            <h5 className="mb-1 me-2">Reports (Available Downloads)</h5>
          </div>
          
          {/* Three Action Buttons */}
          <div className="row g-3">
            <div className="col-lg-4 col-md-6">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body text-center">
                  <FileText size={40} className="text-primary mb-3" />
                  <h6 className="card-title mb-3" style={{ fontSize: "1.0rem", fontWeight: "600" }}>
                    Download Pending Taxes
                  </h6>
                  <button className="btn btn-outline-primary btn-sm w-100">
                    <Download size={16} className="me-2" />
                    Download Pending
                  </button>
                </div>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body text-center">
                  <FileText size={40} className="text-success mb-3" />
                  <h6 className="card-title mb-3" style={{ fontSize: "1.0rem", fontWeight: "600" }}>
                    Download All Taxes
                  </h6>
                  <button className="btn btn-outline-success btn-sm w-100">
                    <Download size={16} className="me-2" />
                    Download All
                  </button>
                </div>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body text-center">
                  <FileText size={40} className="text-info mb-3" />
                  <h6 className="card-title mb-3" style={{ fontSize: "1.0rem", fontWeight: "600" }}>
                    Download Remitted Via Nexus
                  </h6>
                  <button className="btn btn-outline-info btn-sm w-100">
                    <Download size={16} className="me-2" />
                    Download Remitted
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountingTaxes;